import React, { useContext, useEffect, useState } from "react";
import AuditLogsTable from "../Components/AuditLogsTable";
import { DataContext } from "../context/DataContext";
import { Form, Input } from "reactstrap";
import { LuSearch } from "react-icons/lu";
import ChoseMembers from "../Components/ChoseMembers";
import SelectedUser from "../Components/SelectedUser";

function AuditLogs() {
  const {
    getLogs,
    logsData,
    handleSelectUsers,
    selectedUsers,
    removeSelectUsers,
  } = useContext(DataContext);

  useEffect(() => {
    getLogs("", "", 1, selectedUsers[0]?._id || "");
  }, [selectedUsers]);

  return (
    <div>
      <Form className="formWrap" style={{ marginTop: 5 }}>
        <ChoseMembers
          userSkip={true}
          onSelect={(user) => {
            if (selectedUsers?.length != 0) {
              removeSelectUsers(selectedUsers[0]);
            }
            handleSelectUsers(user);
          }}
        />

        <SelectedUser
          onRemove={(user) => removeSelectUsers(user)}
          selectedUsers={selectedUsers}
        />
      </Form>
      <AuditLogsTable
        logs={logsData}
        logsPage={(n) => {
          getLogs("", "", n, selectedUsers[0]?._id || "");
        }}
      />
    </div>
  );
}

export default AuditLogs;
